import * as e from "cache-parser";
import * as t from "fast-defer";
import * as a from "object-code";
var r = {
    d: (e, t) => {
      for (var a in t) r.o(t, a) && !r.o(e, a) && Object.defineProperty(e, a, {
        enumerable: !0,
        get: t[a]
      });
    },
    o: (e, t) => Object.prototype.hasOwnProperty.call(e, t)
  },
  s = {};
r.d(s, {
  h4: () => o,
  UN: () => C,
  uu: () => S,
  Kd: () => I,
  ZF: () => O,
  nv: () => w,
  p: () => l,
  E7: () => d,
  NQ: () => i,
  xK: () => A,
  G6: () => h,
  LN: () => m,
  Bw: () => y,
  Ad: () => u,
  $k: () => v,
  v8: () => E,
  Jk: () => g,
  tI: () => p,
  iS: () => f
});
const n = (e => {
    var t = {};
    return r.d(t, e), t;
  })({
    parse: () => e.parse
  }),
  o = Object.freeze({
    IfModifiedSince: "if-modified-since",
    LastModified: "last-modified",
    IfNoneMatch: "if-none-match",
    CacheControl: "cache-control",
    ETag: "etag",
    Expires: "expires",
    Age: "age",
    XAxiosCacheEtag: "x-axios-cache-etag",
    XAxiosCacheLastModified: "x-axios-cache-last-modified",
    XAxiosCacheStaleIfError: "x-axios-cache-stale-if-error"
  }),
  i = e => {
    if (!e) return "not enough headers";
    const t = e[o.CacheControl];
    if (t) {
      const {
        noCache: a,
        noStore: r,
        mustRevalidate: s,
        maxAge: i,
        immutable: c
      } = (0, n.parse)(String(t));
      if (a || r) return "dont cache";
      if (c) return 31536e6;
      if (s) return 0;
      if (void 0 !== i) {
        const t = e[o.Age];
        return t ? 1e3 * (i - Number(t)) : 1e3 * i;
      }
    }
    const a = e[o.Expires];
    if (a) {
      const e = Date.parse(String(a)) - Date.now();
      return e >= 0 ? e : "dont cache";
    }
    return "not enough headers";
  };
const c = (e => {
  var t = {};
  return r.d(t, e), t;
})({
  deferred: () => t.deferred
});
function d(e) {
  return e ? t => e(t) || 304 === t : e => e >= 200 && e < 300 || 304 === e;
}
function u() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "get";
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return e = e.toLowerCase(), t.some(t => t === e);
}
function f(e, t) {
  var a;
  t.headers || (t.headers = {});
  const {
    etag: r,
    modifiedSince: s
  } = t.cache;
  if (r) {
    const s = !0 === r ? null === (a = e.data) || void 0 === a ? void 0 : a.headers[o.ETag] : r;
    s && (t.headers[o.IfNoneMatch] = s);
  }
  s && (t.headers[o.IfModifiedSince] = !0 === s ? e.data.headers[o.LastModified] || new Date(e.createdAt).toUTCString() : s.toUTCString());
}
function l(e, t) {
  return 304 === e.status && t ? (e.cached = !0, e.data = t.data, e.status = t.status, e.statusText = t.statusText, e.headers = Object.assign(Object.assign({}, t.headers), e.headers), t) : {
    data: e.data,
    status: e.status,
    statusText: e.statusText,
    headers: e.headers
  };
}
function h(e) {
  const t = async t => {
    var a;
    const r = t.id = e.generateKey(t);
    if (!1 === t.cache) return t;
    if (t.cache = Object.assign(Object.assign({}, e.defaults.cache), t.cache), !u(t.method, t.cache.methods)) return t;
    let s = await e.storage.get(r, t);
    const n = t.cache.override;
    e: if ("empty" === s.state || "stale" === s.state || n) {
      if (e.waiting[r] && !n && (s = await e.storage.get(r, t), "empty" !== s.state)) {
        0;
        break e;
      }
      return e.waiting[r] = (0, c.deferred)(), null === (a = e.waiting[r]) || void 0 === a || a.catch(() => {}), await e.storage.set(r, {
        state: "loading",
        previous: n ? s.data ? "stale" : "empty" : s.state,
        data: s.data,
        createdAt: n && !s.createdAt ? Date.now() : s.createdAt
      }, t), "stale" === s.state && f(s, t), t.validateStatus = d(t.validateStatus), t;
    }
    let o;
    if ("loading" === s.state) {
      const a = e.waiting[r];
      if (!a) return await e.storage.remove(r, t), t;
      0;
      try {
        o = await a;
      } catch (e) {
        return t;
      }
    } else o = s.data;
    return t.adapter = () => Promise.resolve({
      config: t,
      data: o.data,
      headers: o.headers,
      status: o.status,
      statusText: o.statusText,
      cached: !0,
      id: r
    }), t;
  };
  return {
    onFulfilled: t,
    apply: () => e.interceptors.request.use(t)
  };
}
async function g(e, t) {
  var a;
  if ("function" == typeof t) return t(e);
  const {
    statusCheck: r,
    responseMatch: s,
    containsHeaders: n
  } = t;
  if (r && !(await r(e.status)) || s && !(await s(e))) return !1;
  if (n) for (const [t, r] of Object.entries(n)) if (!(await r(null !== (a = e.headers[t.toLowerCase()]) && void 0 !== a ? a : e.headers[t]))) return !1;
  return !0;
}
async function p(e, t, a) {
  if ("function" == typeof a) return a(t);
  for (const [r, s] of Object.entries(a)) {
    if ("delete" === s) {
      await e.remove(r, t.config);
      continue;
    }
    const a = await e.get(r, t.config);
    if ("loading" === a.state) continue;
    const n = await s(a, t);
    "delete" !== n ? "ignore" !== n && (await e.set(r, n, t.config)) : await e.remove(r, t.config);
  }
}
function m(e) {
  const t = async (t, a) => {
      var r;
      await e.storage.remove(t, a), null === (r = e.waiting[t]) || void 0 === r || r.reject(), delete e.waiting[t];
    },
    a = async a => {
      var r, s, n;
      const i = a.id = null !== (r = (n = a.config).id) && void 0 !== r ? r : n.id = e.generateKey(a.config);
      if (null !== (s = a.cached) && void 0 !== s || (a.cached = !1), a.cached) return a;
      const c = a.config.cache;
      if (!c) return Object.assign(Object.assign({}, a), {
        cached: !1
      });
      const d = a.config,
        u = await e.storage.get(i, d);
      if ((null == c ? void 0 : c.update) && (await p(e.storage, a, c.update)), "loading" !== u.state) return a;
      if (!u.data && !(await g(a, c.cachePredicate))) return await t(i, d), a;
      for (const e of Object.keys(a.headers)) e.startsWith("x-axios-cache") && delete a.headers[e];
      c.etag && !0 !== c.etag && (a.headers[o.XAxiosCacheEtag] = c.etag), c.modifiedSince && (a.headers[o.XAxiosCacheLastModified] = !0 === c.modifiedSince ? "use-cache-timestamp" : c.modifiedSince.toUTCString());
      let f = c.ttl || -1;
      if (null == c ? void 0 : c.interpretHeader) {
        const r = e.headerInterpreter(a.headers);
        if ("dont cache" === r) return await t(i, d), a;
        f = "not enough headers" === r ? f : r;
      }
      const h = l(a, u.data);
      "function" == typeof f && (f = await f(a)), c.staleIfError && (a.headers[o.XAxiosCacheStaleIfError] = String(f));
      const m = {
          state: "cached",
          ttl: f,
          createdAt: Date.now(),
          data: h
        },
        v = e.waiting[i];
      return v && (v.resolve(m.data), delete e.waiting[i]), await e.storage.set(i, m, d), a;
    },
    r = async a => {
      var r;
      const s = a.config;
      if (!(null == s ? void 0 : s.cache) || !s.id) throw a;
      const n = await e.storage.get(s.id, s),
        o = s.cache;
      if ("loading" !== n.state || "stale" !== n.previous) throw await t(s.id, s), a;
      if (null == o ? void 0 : o.staleIfError) {
        const t = "function" == typeof o.staleIfError ? await o.staleIfError(a.response, n, a) : o.staleIfError;
        if (!0 === t || "number" == typeof t && n.createdAt + t > Date.now()) return null === (r = e.waiting[s.id]) || void 0 === r || r.resolve(n.data), delete e.waiting[s.id], await e.storage.set(s.id, {
          state: "stale",
          createdAt: Date.now(),
          data: n.data
        }, s), {
          cached: !0,
          config: s,
          id: s.id,
          data: n.data.data,
          headers: n.data.headers,
          status: n.data.status,
          statusText: n.data.statusText
        };
      }
      throw a;
    };
  return {
    onFulfilled: a,
    onRejected: r,
    apply: () => e.interceptors.response.use(a, r)
  };
}
const v = e => !!e && !!e["is-storage"];
function w(e) {
  const t = e.data.headers;
  return o.ETag in t || o.LastModified in t || o.XAxiosCacheEtag in t || o.XAxiosCacheStaleIfError in t || o.XAxiosCacheLastModified in t;
}
function y(e) {
  return e.createdAt + e.ttl <= Date.now();
}
function I(_ref) {
  let {
    set: e,
    find: t,
    remove: a
  } = _ref;
  return {
    "is-storage": 1,
    set: e,
    remove: a,
    get: async (r, s) => {
      const n = await t(r, s);
      if (!n) return {
        state: "empty"
      };
      if ("cached" !== n.state || !y(n)) return n;
      if (w(n)) {
        const t = {
          state: "stale",
          createdAt: n.createdAt,
          data: n.data
        };
        return await e(r, t, s), t;
      }
      return await a(r, s), {
        state: "empty"
      };
    }
  };
}
function S() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
  const t = I({
    set: (e, a) => {
      t.data[e] = a;
    },
    remove: e => {
      delete t.data[e];
    },
    find: a => {
      const r = t.data[a];
      return e && void 0 !== r ? "function" == typeof structuredClone ? structuredClone(r) : JSON.parse(JSON.stringify(r)) : r;
    }
  });
  return t.data = Object.create(null), t;
}
const x = (e => {
    var t = {};
    return r.d(t, e), t;
  })({
    hash: () => a.hash
  }),
  b = /^\/|\/$/g;
function C(e) {
  return t => {
    if (t.id) return t.id;
    const a = e(t);
    return "string" == typeof a || "number" == typeof a ? `${a}` : `${(0, x.hash)(a)}`;
  };
}
const A = C(_ref2 => {
  let {
    baseURL: e = "",
    url: t = "",
    method: a = "get",
    params: r,
    data: s
  } = _ref2;
  return e && (e = e.replace(b, "")), t && (t = t.replace(b, "")), a && (a = a.toLowerCase()), {
    url: e + (e && t ? "/" : "") + t,
    params: r,
    method: a,
    data: s
  };
});
function E(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var a, r, s, n, o;
  const c = e;
  if (c.storage = t.storage || S(), !v(c.storage)) throw new Error("Use buildStorage() function");
  return c.waiting = t.waiting || {}, c.generateKey = t.generateKey || A, c.headerInterpreter = t.headerInterpreter || i, c.requestInterceptor = t.requestInterceptor || h(c), c.responseInterceptor = t.responseInterceptor || m(c), c.debug = t.debug, c.defaults.cache = {
    update: t.update || {},
    ttl: null !== (a = t.ttl) && void 0 !== a ? a : 3e5,
    methods: t.methods || ["get"],
    cachePredicate: t.cachePredicate || {
      statusCheck: e => e >= 200 && e < 400
    },
    etag: null === (r = t.etag) || void 0 === r || r,
    modifiedSince: null !== (s = t.modifiedSince) && void 0 !== s ? s : !1 === t.etag,
    interpretHeader: null === (n = t.interpretHeader) || void 0 === n || n,
    staleIfError: null === (o = t.staleIfError) || void 0 === o || o,
    override: !1
  }, c.requestInterceptor.apply(), c.responseInterceptor.apply(), c;
}
function O(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return I({
    find: a => {
      const r = e.getItem(t + a);
      return r ? JSON.parse(r) : void 0;
    },
    remove: a => {
      e.removeItem(t + a);
    },
    set: (a, r) => {
      const s = () => e.setItem(t + a, JSON.stringify(r));
      try {
        return s();
      } catch (r) {
        const n = Object.entries(e).filter(e => e[0].startsWith(t)).map(e => [e[0], JSON.parse(e[1])]);
        for (const t of n) "cached" === t[1].state && y(t[1]) && !w(t[1]) && e.removeItem(t[0]);
        try {
          return s();
        } catch (t) {
          const a = n.sort((e, t) => (e[1].createdAt || 0) - (t[1].createdAt || 0));
          for (const t of a) {
            e.removeItem(t[0]);
            try {
              return s();
            } catch (e) {}
          }
        }
        e.removeItem(t + a);
      }
    }
  });
}
var j = s.h4,
  N = s.UN,
  T = s.uu,
  M = s.Kd,
  L = s.ZF,
  K = s.nv,
  X = s.p,
  k = s.E7,
  D = s.NQ,
  J = s.xK,
  P = s.G6,
  R = s.LN,
  U = s.Bw,
  q = s.Ad,
  H = s.$k,
  $ = s.v8,
  F = s.Jk,
  G = s.tI,
  W = s.iS;
export { j as Header, N as buildKeyGenerator, T as buildMemoryStorage, M as buildStorage, L as buildWebStorage, K as canStale, X as createCacheResponse, k as createValidateStatus, D as defaultHeaderInterpreter, J as defaultKeyGenerator, P as defaultRequestInterceptor, R as defaultResponseInterceptor, U as isExpired, q as isMethodIn, H as isStorage, $ as setupCache, F as testCachePredicate, G as updateCache, W as updateStaleRequest };